module.exports = __webpack_public_path__ + "static/media/4d-engine-3.d441fb28.jpg";